import store from '@/store';

import PopupAlert from '@/components/base/PopupAlert.vue';
import PopupConfirm from '@/components/base/PopupConfirm.vue';
import PopupPrompt from '@/components/base/PopupPrompt.vue';
import PopupGoto from '@/components/base/PopupGoto.vue';
import BasePreview from '@/components/BasePreview.vue';

export default {
  type: {
    alert: 'alert',
    confirm: 'confirm',
  },

  addAlert(text, desc = '') {
    const component = PopupAlert;
    const args = [text, desc];
    return this.add({ component, args });
  },

  addConfirm(text, desc = '') {
    const component = PopupConfirm;
    const args = [text, desc];
    return this.add({ component, args });
  },

  addPrompt(text, desc = '', defValue = '') {
    const component = PopupPrompt;
    const args = [text, desc, defValue];
    return this.add({ component, args });
  },

  /**
   * Алерт с кнопкой-ссылкой вместо OK: `to` — объект роута, `buttonText` —
   * подпись кнопки. Резолвится true при переходе и false при закрытии.
   */
  addGoto(text, to, buttonText, desc = '') {
    const component = PopupGoto;
    const args = [text, to, buttonText, desc];
    return this.add({ component, args });
  },

  /**
   * Полноэкранный просмотр изображений, видео и PDF (BasePreview).
   * items — [{ type: 'image' | 'video' | 'pdf', src }], index — с какого начать.
   * Через диспетчер, а не из разметки вызывающего: внутри шторки оверлей
   * иначе накрывает только её (см. BasePreview).
   *
   * popup — свой объект-описатель, если просмотр нужно закрыть снаружи
   * (см. комментарий к add): в него запишутся component и args.
   */
  addPreview(items, index = 0, popup = {}) {
    Object.assign(popup, { component: BasePreview, args: [items, index] });
    return this.add(popup);
  },

  /**
   * Попап живёт в сторе, а не в разметке открывшего его компонента, поэтому
   * смена роута сама его не убирает. Если внутри *PopupWrappable есть ссылка
   * наружу без target="_blank", попап нужно закрывать вручную — например в
   * beforeDestroy открывшего компонента (пример: CrmBoardApi и попап заявки).
   * Для этого держите ссылку на переданный сюда объект и зовите resolve().
   */
  add(popup) {
    const promise = new Promise((resolve) => {
      popup.resolve = resolve; // eslint-disable-line no-param-reassign
    });

    store.commit('popup/add', popup);

    return promise;
  },

  resolve(popup, result) {
    popup.resolve(result);
    store.commit('popup/remove', popup);
  },
};
